import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Orderstatus = ({ openConsultationDialog, setOpenConsultationDialog, setgetOrder, selectedOrder, mode, selectedsubOrder, setgetSubOrder }) => {
    const title = mode === "orders" ? "Edit your order status" : "Edit your sub order status";
    //handle close
    const handleClose = () => {
        setOpenConsultationDialog(false);
        //empty the values
        SetOrderStatus('')
        SetSubOrderStatus('')
    };

    const [orderStatus, SetOrderStatus] = useState('');

    //handle change order status
    const handleOrderStatus = async (selectedOrder) => {

        try {
            const response = await instance.patch('/Order/changeStatus',
                {
                    order_id: selectedOrder._id, // Use `selectedOrder` to access `order_id`
                    status: orderStatus
                }
            )

            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetOrder(true)
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        }
    }
    useEffect(() => {
        if (selectedOrder) {
            SetOrderStatus(selectedOrder?.status)// Set the initial order status
        }
    },[selectedOrder])
    // console.log(orderStatus);
    
    const statuses = ["In Payment", "In Progress", "In Transit", "Completed", "Delivered", "Canceled","Alteration"];

    // Define restrictions
    const statusRestrictions = {
        "Unassigned":statuses,
        "Assigned":statuses,
        "In Payment": statuses, // Show all statuses
        "In Progress": statuses.filter(status => status !== "In Payment"),
        "In Transit": statuses.filter(status => !["In Payment", "In Progress"].includes(status)),
        "Completed": statuses.filter(status => !["In Payment", "In Progress", "In Transit"].includes(status)),
        "Delivered": statuses.filter(status => !["In Payment", "In Progress", "In Transit", "Completed"].includes(status)),
        "Canceled": statuses, 
        "Alteration": statuses, 
    };

    // Filter options based on selected orderStatus
    const filteredStatuses = orderStatus ? statusRestrictions[selectedOrder?.status] : statuses;
    //handle change suborder status
    const [suborderStatus, SetSubOrderStatus] = useState('');

    const handleSubOrderStatus = async (selectedsubOrder) => {

        try {
            const response = await instance.patch('/Order/changeSubOrderStatus',
                {
                    order_id: selectedsubOrder._id, // Use `selectedOrder` to access `order_id`
                    status: suborderStatus
                }
            )

            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetSubOrder(true)
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        }
    }

    return (
        <>
            <React.Fragment>
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={openConsultationDialog}
                    className="admin-admins"
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                        {mode ? `Edit ${mode} status` : `Add ${mode} status`}
                        <Typography>{title}</Typography>
                    </DialogTitle>
                    <hr style={{ margin: "10px 0px" }} />
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        {mode === "orders" ?
                            (
                                <section className="add-admin">
                                    <Grid container spacing={2}>
                                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                            <div className='admin-textfiled'>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Select Order Status</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        label="Select Order Status"
                                                        required
                                                        placeholder="Select Order Status"
                                                        fullWidth
                                                        value={orderStatus}
                                                        onChange={(e) => SetOrderStatus(e.target.value)}
                                                    >
                                                        {filteredStatuses.map((status) => (
                                                            <MenuItem key={status} value={status}>
                                                                {status}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </section>
                            ) : (
                                <section className="add-admin">
                                    <Grid container spacing={2}>
                                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                            <div className='admin-textfiled'>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Select SubOrder Status</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        label="Select SubOrder Status"
                                                        required
                                                        placeholder="Select SubOrder Status"
                                                        fullWidth
                                                        value={suborderStatus}
                                                        onChange={(e) => SetSubOrderStatus(e.target.value)}
                                                    >
                                                        <MenuItem value="In Progress">In Progress</MenuItem>
                                                        <MenuItem value="Completed">Completed</MenuItem>
                                                        <MenuItem value="Canceled">Canceled</MenuItem>
                                                        {/* <MenuItem value="In Transit">In Transit</MenuItem> */}
                                                        {/* <MenuItem value="In Payment">In Payment</MenuItem> */}
                                                        {/* <MenuItem value="Delivered">Delivered</MenuItem> */}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </section>
                            )
                        }
                    </DialogContent>
                    {mode === "orders" ?
                        (
                            <DialogActions>
                                <Button className="cancel-btn" onClick={handleClose}>
                                    Cancel
                                </Button>
                                <Button className="add-btn" onClick={() => handleOrderStatus(selectedOrder)}>Change Status</Button>
                            </DialogActions>
                        ) : (
                            <DialogActions>
                                <Button className="cancel-btn" onClick={handleClose}>
                                    Cancel
                                </Button>
                                <Button className="add-btn" onClick={() => handleSubOrderStatus(selectedsubOrder)}>change Status</Button>
                            </DialogActions>
                        )
                    }
                </BootstrapDialog>
            </React.Fragment>
        </>
    )
}

export default Orderstatus;